import React from "react";
import VideoModal from "../ModalVideo/VideoModal";
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';
// import abImg from '../../images/about/about-1/1.jpg';
import abImg2 from '../../images/about/about-1/2.jpg';
import RollingText from "../RollingText/RollingText";

const About = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }


    return (
        <section id="about" className={"" + props.hclass}>
            <div className="about-wrap">
                <div className="content">
                    <h2 className="scroll-text-animation" data-animation="fade_from_right ">About Luxrock Realty</h2>
                    <p className="fade_bottom">At Luxrock, we’re more than just a real estate consulting firm. We are your trusted strategic partners, committed to helping you make informed, secure, and profitable property decisions.

                        With years of hands-on experience and deep rooted knowledge of the local real estate landscape, we bring clarity and confidence to every transaction. Our core strength lies in delivering personalized, research backed consulting services tailored for both residential and commercial needs, whether you're a first-time buyer, seasoned investor, or growing business.

                        At Luxrock, we believe real estate is not just about buying or selling. It's about building a future. We focus on creating long-term value for our clients through integrity, transparency, and professionalism. Our goal is to simplify the complex, reduce risks, and unlock growth opportunities, all while keeping your vision at the center.

                        Partner with us to experience real estate consulting that goes beyond transactions and into lasting relationships.</p>
                    <div className="about-btn ">
                        <Link onClick={ClickHandler} to="/aboutus" className="theme-btn">
                            <RollingText text={'Discover More'} />
                        </Link>
                        <div className="video-wrap">
                            <div className="video-holder">
                                <VideoModal />
                            </div>
                            <span>Watch Videos</span>
                        </div>
                    </div>
                    <div className="about-funfact fade_bottom">
                        <h3><span><CountUp end={7} enableScrollSpy /></span><span className="icon">+</span></h3>

                        <h4>Years Of <br />
                            Experience</h4>
                    </div>
                </div>
            </div>
            <div className="image">
                {/* <div className="image-1  poort-in-right">
                    <img src={abImg} alt="" />
                </div> */}
                <div className="image-2 poort-in-right">
                    <img src={abImg2} alt="" />
                </div>
            </div>
        </section>
    )
}

export default About;
